import React from 'react'

const Header = () => {
  return (
    <div className='header' >Welcome to the ERC Calculator. Read below or checkout the video! <br/><a href='https://youtu.be/NL-f3QcM1tY' >--How to video--</a></div>
  )
}

export default Header 